import Track from '@/lib/track'
export function haTrack(...args) {

  return Track.event(args[1], args[2])
}